// NOTE: this file was auto-generated with `libraries/icons/src/_private/transform.ts`
// Any manual edits will be overwritten via `rush build`

import { SVGProps } from 'react';

const Circle = (props: SVGProps<SVGSVGElement>) => (
	<svg width="1em" height="1em" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M12 21.375a8.875 8.875 0 1 0 0-17.75 8.875 8.875 0 0 0 0 17.75Zm0 1c-5.454 0-9.875-4.421-9.875-9.875S6.546 2.625 12 2.625s9.875 4.421 9.875 9.875-4.421 9.875-9.875 9.875Z"
			fill="#fff"
		/>
	</svg>
);
export default Circle;
